import {DatePicker as ArkDatePicker} from '@ark-ui/react/date-picker'
import {DatePickerViewControl} from '../view_control'
import './index.less'

const NUM_OF_COLUMNS = 4

export const DatePickerYearView = () => {
	return (
		<ArkDatePicker.View view="year">
			<ArkDatePicker.Context>
				{ctx => (
					<>
						<DatePickerViewControl />
						<ArkDatePicker.Table columns={NUM_OF_COLUMNS}>
							<ArkDatePicker.TableBody>
								{ctx.getYearsGrid({columns: NUM_OF_COLUMNS}).map((years, rowIndex) => (
									<ArkDatePicker.TableRow key={rowIndex}>
										{years.map(year => (
											<ArkDatePicker.TableCell key={year.value} value={year.value} disabled={year.disabled}>
												<ArkDatePicker.TableCellTrigger>{year.label}</ArkDatePicker.TableCellTrigger>
											</ArkDatePicker.TableCell>
										))}
									</ArkDatePicker.TableRow>
								))}
							</ArkDatePicker.TableBody>
						</ArkDatePicker.Table>
					</>
				)}
			</ArkDatePicker.Context>
		</ArkDatePicker.View>
	)
}
